/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import ListingPage from './ListingPage';
import { linkFormatter } from '../util/LinkFormatter';
import PropTypes from 'prop-types';


/**
 * Domains page of web monitor.
 */
export default class Domains extends Component {
    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    render() {
        let columns = {
            'Name': 'name',
            '#Rcpt': 'rcp',
            '#KBytes': 'kb',
            '#Conn': 'conn'
        }

        let columnFormatter = {
            Name: linkFormatter.linkDomain
        }
        return (
            <ListingPage name='domain'
                         defaultName='*'
                         urlPath='/domains'
                         items='domains'
                         columns={columns}
                         showError={this.props.showError}
                         showLastError={true}
                         showViewOptions={true}
                         columnFormatter={columnFormatter}
                         setRefresh={this.props.setRefresh}
                         setRefreshInterval={this.props.setRefreshInterval}/>
        );
    }
}
